import { Link } from "react-router-dom";
import style from './index.module.scss';

function Logo({ black = false}) {
	return (
		<Link to="/" className={style?.['logo-wrapper']}>
			<div className={`${style?.logo} logo ${black ? style['black'] : ""}`}></div>
		</Link>
	);
}

export default Logo;
